import '@/utils/validation.ts';

import { createApp } from 'vue';

import UnitSummary from '@/components/purchase/unitSummary/UnitSummary.vue';
import i18n from '@/locales';


// Créer l'app Vue de base à partir de son constructeur
const app = createApp({});

// Ajouter les plugins/extensions globales à l'application
app.use(i18n);

// Ajouter le ou les composants qui devront être reconnus par l'application; <hello-world></hello-world>
app.component('UnitSummary', UnitSummary);

// Monter l'application sur un élément qui lui sera dédié dans le gabarit Razor; <div id="helloWorldApp"></div>
app.mount('#unitPurchaseSummaryApp');
